import { AbstractControl } from '@angular/forms';
import { PasswordStrengthModel } from 'app/shared/validators/password-strength.model';
export class CustomValidators {

    static MatchPassword(AC: AbstractControl) {
        let passwordValue = AC.get('newPassword').value; // to get value in input tag
        let confirmPassword = AC.get('confirmPassword'),
            confirmPasswordValue = confirmPassword.value; // to get value in input tag
        if (passwordValue != confirmPasswordValue && confirmPassword.dirty) {
            AC.get('confirmPassword').setErrors({ matchPassword: 'Passwords do not match' })
        } else {
            return null;
        }
    }

    static MaskedMinLength(minLength: number) {
        return (AC: AbstractControl) => {
            if (AC.dirty) {
                let value = AC.value.replace(/[_]/gi, "");
                if (value.length < minLength)
                    return { minLength }
            } else {
                return null;
            }
        }
    }

    static PasswordStrength(config: PasswordStrengthModel) {
        return (AC: AbstractControl) => {
            if (AC.dirty) {
                let value = AC.value;
                if (value.length < config.minLength) {
                    const minLength = `Min Length Is: ${config.minLength}`;
                    return { minLength }
                }
                if (config.digitRequired && !new RegExp(/[0-9]/).test(value)) {
                    const passwordStrength = 'Digit Is Required';
                    return { passwordStrength }
                }
                if (config.upperCaseCharacterRequired && !new RegExp(/[A-Z]/).test(value)) {
                    const passwordStrength = 'Uppercase Alphabet Is Required';
                    return { passwordStrength }
                }
                if (config.upperCaseCharacterRequired && !new RegExp(/[$$!%*#?&@]/).test(value)) {
                    const passwordStrength = 'Special Character Is Required ($!%*#?&@)';
                    return { passwordStrength }
                }
            } else {
                return null;
            }
        }
    }

    static isEmail(){
        return (AC: AbstractControl) => {
            if(AC.dirty){
                let emailRegex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])[^\s]?)*$/i;
                // let whitespaceRegex = /^\s/
                if(AC.value && !emailRegex.test(AC.value)){
                    const invalidEmail = 'Please enter a valid Email Address';
                    return { invalidEmail };
                }
                // else if(AC.value && !whitespaceRegex.test(AC.value)){
                //     const noWhitespaceEmail = "No whitespace allowed";
                //     return { noWhitespaceEmail };
                // }
                else{
                    return null;
                }
            }
        }
    }

    static isName(){
        return (AC: AbstractControl) => {
            if(AC.dirty){

                let regexp = /^[a-zA-Z- ']+(?: \S+ \D+)*$/g;
                if(AC.value && !regexp.test(AC.value)) {
                    const lettersOnly = "No numbers or special characters";
                    return { lettersOnly };
                }
                return null;
            } else {
                return null;
            }

        }
    }

    static isNumeric() {
        return (AC: AbstractControl) => {
            if (AC.dirty) {
                let regexp = /^[0-9]+([.][0-9]+)?$/g;
                if (AC.value && !regexp.test(AC.value)) {
                    const numericRequired = "Only numbers";
                    return { numericRequired }
                }
                return null;
            } else {
                return null;
            }
        }
    }

    static isIntegerSNAP() {
        return (AC: AbstractControl) => {
            if (AC.dirty) {
                let regexp = /^[0-9]+([,.][0-9]+)?$/g;
                if (AC.value && !regexp.test(AC.value)) {
                    const numericRequired = "Only positive numbers";
                    return { numericRequired }
                }
                let regexpD = /^-?[0-9][^\.,]*$/g;               
                if (AC.value && !regexpD.test(AC.value)) {
                    const numericRequired = "Only whole dollars";
                    return { numericRequired }
                }
                if (AC.value && AC.value > 9999) {
                    const max = "$9999";
                    return { max }
                }
                return null;
            } else {
                return null;
            }
        }
    }

    static isAgeInRange(){
        return (AC: AbstractControl) => {
            if(AC.dirty){
                let regexp = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

                let min = AC.errors.min;
                let max = AC.errors.max;
                let input = new Date(AC.value);
                
                if(input.toDateString() != "Invalid Date" && regexp.test(input.toDateString())){
                    if(input < min ||  input > max){
                        const isAgeInRange = 'Date of Birth is out of eligibility range.'
                        return { isAgeInRange };
                    }
                    else{
                        return null;
                    }
                }
                else{
                    return null;
                }
            }
            else{
                return null;
            }
        }
    }


    // static isDate(){
    //     //matDatepickerParse
    //     return (AC: AbstractControl)=>{
    //         if(AC.dirty){
    //             let regexp = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
    //             if(AC.value && !regexp.test(AC.value)){
    //                 const wrongDate="Wrong Date";
    //                 return {wrongDate} 
    //             }
    //             return null;        
    //         }else{
    //            return null;
    //         }
    //     }
    // }

}


// WEBPACK FOOTER //
// ./src/app/shared/validators/custom-validators.ts